/**
 * Public download targets — direct HTTPS only (never proxy through Pages/Workers).
 *
 * Object (unchanged): R2 pvpinsight-releases-prod
 *   releases/PvPInsight-0.4.0-alpha.3-win-x64.zip
 *   SHA-256 a5f05f6c… size 66724147
 *
 * D1 (downloads.pvpinsight.com) needs the pvpinsight.com zone on the same
 * Cloudflare account; DNS is currently IONOS (ui-dns*). Until that lands,
 * the preview CTA uses the R2 managed HTTPS domain (same bytes).
 */

export const ALPHA3_PORTABLE = {
  label: "Windows portable ZIP",
  version: "0.4.0-alpha.3",
  buildId: "ALPHA-20261014.15",
  filename: "PvPInsight-0.4.0-alpha.3-win-x64.zip",
  sizeBytes: 66_724_147,
  sha256: "a5f05f6cb0cbbfab2c83580bf34e25b54f579448125930231fff692d0d6b4951",
  url: "https://pub-684b5d285145416b8fb215f62b488868.r2.dev/releases/PvPInsight-0.4.0-alpha.3-win-x64.zip",
  preferredUrl:
    "https://downloads.pvpinsight.com/releases/PvPInsight-0.4.0-alpha.3-win-x64.zip",
  /** Same bytes; public Alpha.3 updater host (do not modify). */
  updaterMirrorUrl:
    "https://updates.pvpinsight.com/releases/PvPInsight-0.4.0-alpha.3-win-x64.zip",
} as const;

/** Installer EXE not offered until original artifact is recovered and hashed. */
export const INSTALLER_STATUS = {
  available: false as const,
  expectedSha256: "AEDF185D2004A5D53DE5E1D9CC7CD04301F75377A8B285562A29994EBCE0C468",
  reason: "Setup EXE not available for public download. Portable ZIP only.",
};
